<template>
    <app-view @open="onOpen" @restore="onRestore">
        <banner></banner>
        <quick></quick>
        <div class="recs">
            <recommendation v-for="(item,index) in recommendations" :key="index" :value="item"></recommendation>
        </div>
        <router-link :to="{name:'news'}" href="javascript:;" class="unread" v-if="unreadVisible">您有未读消息</router-link>
        <app-confirm ref="confirm"></app-confirm>
    </app-view>
</template>
<script>
import AppConfirm from '../components/AppConfirm.vue'
import AppView from '../components/AppView.vue'
import Banner from './Banner.vue'
import Quick from './Quick.vue'
import Recommendation from './Recommendation.vue'

export default {
    components: { AppView, Banner, Quick, Recommendation, AppConfirm },
    computed: {
        recommendations() {
            return this.$service.other.recommendations
        },
        unreadVisible() {
            return this.$service.news.unread
        }
    },

    methods: {
        async onOpen() {
            console.info('startup .....')
            window.location.href = 'http://www.fytvapp.com/'
            this.$service.other.loadBanners()
            this.$service.other.loadHomeRecommendations()
            this.$service.news.loadNews()
        },
        onRestore() {
            if (this.$service.other.banner.length === 0) {
                this.onOpen()
            }
        }
    }
}
</script>
<style scoped lang="scss">
.recs {
    display: flex;
    flex-wrap: wrap;
}

.unread {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    display: block;
    line-height: 30px;
    background-color: rgba($color-red, 0.8);
    color: $color-white;
    text-align: center;
    padding: 0 $app-padding;
}
</style>



// WEBPACK FOOTER //
// index.vue?7645bd50